module.exports = __webpack_public_path__ + "img/Ma.5518a133.png";